
import { Component, Provide, Inject, Vue } from "vue-property-decorator";
import {
  ICProdsProviderData,
  ICProdsProviderMethods
} from "@/models/providers/contractProduct";
import {
  ISegmentResultsProviderData,
  ISegmentResultsProviderMethods
} from "@/models/providers/segments";

@Component
export default class SegmentResultsToCProdsProviderMapping extends Vue {
  // Inject
  @Inject({ from: "segmentResultsProvider" })
  public segmentResultsProvider!: () => ISegmentResultsProviderData;

  @Inject({ from: "segmentResultsProviderMethods" })
  public $segmentResultsProviderMethods!: ISegmentResultsProviderMethods;

  // Life-cycle methods
  public render() {
    return (
      this.$scopedSlots?.default &&
      this.$scopedSlots.default({
        $cProdsData: this.cProdsProvider(),
        $cProdsMethods: this.cProdsProviderMethods
      })
    );
  }

  // Computed

  public get $segmentResultsData() {
    return this.segmentResultsProvider();
  }

  // Provide

  @Provide()
  public get cProdsProviderMethods(): ICProdsProviderMethods {
    return {
      doQuickSearch: this.$segmentResultsProviderMethods.doQuickSearch,
      onFiltersChange: this.$segmentResultsProviderMethods.onFiltersChange,
      onLimitChange: this.$segmentResultsProviderMethods.onLimitChange,
      onPageChange: this.$segmentResultsProviderMethods.onPageChange,
      onSort: this.$segmentResultsProviderMethods.onSort,
      reloadData: this.$segmentResultsProviderMethods.reloadData
    };
  }

  @Provide()
  public cProdsProvider(): ICProdsProviderData {
    return {
      availableFilters: this.$segmentResultsData.availableFilters,
      availableSorters: this.$segmentResultsData.availableSorters,
      activeFilters: this.$segmentResultsData.activeFilters,
      activeSort: this.$segmentResultsData.table.sort,
      canShowMore: this.$segmentResultsData.canShowMore,
      debounceSearch: this.$segmentResultsData.debounceSearch,
      enableFiltering: this.$segmentResultsData.enableFiltering,
      enableSorting: this.$segmentResultsData.enableSorting,
      hasProducts: this.$segmentResultsData.hasResults,
      isLoading: this.$segmentResultsData.table.loading,
      limit: this.$segmentResultsData.table.limit,
      page: this.$segmentResultsData.table.page,
      products: this.$segmentResultsData.table.data,
      searchQuery: this.$segmentResultsData.searchQuery,
      table: this.$segmentResultsData.table,
      total: this.$segmentResultsData.table.total
    };
  }
}
